var _rect, _rect2, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebIconh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#36A6A4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_818_4983",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#36A6A4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_818_4983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.0001C0.280051 10.2846 -2.16667 10.6667 -3 11.0001V13.5C-1.83333 13.5 0.631789 14.0439 2 14.5C8 16.5 11 15 13 12.5C14.8019 10.2476 18.6667 4.16667 20 1L12.5 -1.5L10 6.5C9.16667 8.33336 8 12 3.5 11.0001Z",
    fill: "#179593"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.5001C7.28005 17.7846 -0.666667 17.6667 -1.5 18L0 19.5C1.16667 19.5 7.5 20.5 9 22C13.4721 26.4721 18 22.5 20 20C21.8019 17.7476 25.6667 11.6667 27 8.5L23 4L17.5 14C16 16 15 19.5 10.5 18.5001Z",
    fill: "#179593"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_818_4983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 7.83325C9.70266 7.83325 7.8335 9.70242 7.8335 11.9999C7.8335 14.2974 9.70266 16.1666 12.0002 16.1666C14.2977 16.1666 16.1668 14.2974 16.1668 11.9999C16.1668 9.70242 14.2977 7.83325 12.0002 7.83325ZM8.66683 11.9999C8.66683 11.6253 8.73183 11.2658 8.84641 10.9295L9.50016 11.5833L10.3335 12.4166V13.2499L11.1668 14.0833L11.5835 14.4999V15.3045C9.94225 15.0983 8.66683 13.6966 8.66683 11.9999ZM14.6377 14.0303C14.3656 13.8112 13.9531 13.6666 13.6668 13.6666V13.2499C13.6668 13.0289 13.579 12.8169 13.4228 12.6607C13.2665 12.5044 13.0545 12.4166 12.8335 12.4166H11.1668V11.1666C11.3878 11.1666 11.5998 11.0788 11.7561 10.9225C11.9124 10.7662 12.0002 10.5543 12.0002 10.3333V9.91659H12.4168C12.6378 9.91659 12.8498 9.82879 13.0061 9.67251C13.1624 9.51623 13.2502 9.30427 13.2502 9.08325V8.912C14.4702 9.40742 15.3335 10.6041 15.3335 11.9999C15.3334 12.7352 15.0886 13.4496 14.6377 14.0303Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_818_4983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIconh);
export default __webpack_public_path__ + "static/media/webIconh.70a216bddf358411de770b33d68e9a82.svg";
export { ForwardRef as ReactComponent };